<template>
  <div class="signDetails" v-show="isShow">
    <p>参数编号：{{sign_no2}}</p>
    <!-- <p>标点编号：{{sign_no1}}</p> -->
    <p>美容/治疗项目：{{item_info}}</p>
    <p>治疗模板：{{module_info}}</p>
    <p v-for="(item,index) in paramList" :key="index">{{item.label}}:{{item.value}}</p>
    <!-- <p>Power:8.0</p>
        <p>Dwell time:500</p>
        <p>Spacing:500</p>
        <p>Flunce:500</p>
        <p>RF Power:15</p>
    <p>RF Dewll time:3.0</p>-->
  </div>
</template>
<script>
import getCosmetologyTreatDetail from "../gql/getCosmetologyTreatDetail.gql";
export default {
  name: "signDetails",
  // inject: {
  //   isOpenDialog2: ["isOpenDialog"]
  // },
  data() {
    return {
      // sign_no:'',
      item_info: "",
      module_info: "",
      param_value: "",
      paramList: []
    };
  },
  props: {
    toggleStatusSign: {
      type: Boolean,
      default: () => false
    },
    signDetails: {
      type: Boolean,
      default: () => false
    },
    signId: {
      type: Number,
      default: () => -1
    },
    sign_no: {
      type: String,
      default: () => ""
    },
    detail_title: {
      type: String,
      default: () => ""
    }
  },
  watch: {
    async signId(val) {
      if (val && val > -1) {
        // console.log(val);
        await this.getCosmetologyTreatDetailData(val);
      } else {
        this.reset();
      }
    },
    async isShow(val) {
      if (val) {
        if (this.signId && this.signId > -1) {
          await this.getCosmetologyTreatDetailData(this.signId);
        }
      }
    },
    async signDetails(val) {
      // console.log(val);
      if (val) {
        if (this.signId && this.signId > -1) {
          await this.getCosmetologyTreatDetailData(this.signId);
        }
      }
    }
  },
  computed: {
    isShow() {
      return this.toggleStatusSign && this.signDetails;
    },
    sign_no1: {
      get() {
        return this.sign_no;
      },
      set(val) {
        this.$emit("setsign_no", val);
      }
    },
    sign_no2: {
      get() {
        return this.detail_title;
      },
      set(val) {
        this.$emit("setTitle_detail", val);
      }
    }
  },
  methods: {
    reset() {
      this.item_info = "";
      this.module_info = "";
      this.param_value = "";
      this.paramList = [];
    },
    async getCosmetologyTreatDetailData(ID) {
      try {
        let res = await this.$apollo.query({
          query: getCosmetologyTreatDetail,
          fetchPolicy: "no-cache",
          variables: {
            id: ID
          }
        });
        this.hasIdsetData(res.data.getCosmetologyTreatDetail);
      } catch (error) {
        console.log(error);
      }
    },

    hasIdsetData(item) {
      // 设置文字
      //   this.sign_no = item.sign_no;
      this.item_info = item.item_info.item_name;
      this.device_info = item.device_info.device_name;
      this.module_info = item.module_info.module_name;

      // 设置selectList
      this.paramList = JSON.parse(item.param_value);
    }
  }
};
</script>
<style lang="less" scoped>
.signDetails {
  padding: 10px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: white;
}
</style>